
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's182ab2d6c997515f': `Legg den til på Hjem-skjermen din for å få en bedre brukeropplevelse og raskere tilgang.`,
's224cbcec014ef6b5': `Trykk på Del-knappen i navigasjonslinjen`,
's37a9e8aec5713460': `Mer`,
's386eca8362ff6155': `Trykk på Mer hvis det ikke er noe delingsikon`,
's4e1e10a6ca408245': `Trykk på "Legg til på Hjem-skjerm"`,
's6196153c4b0c1ea0': `Installer`,
's633502f7cff4f847': `Åpne menyen i nettleseren din`,
's681e399d63311fba': `Vis galleri`,
's7f0591f08e318eda': `Trykk på Mer i delingsmenyen`,
's8114bd55cae5a22b': `Velg Legg til i Dock`,
's922329d6f6213590': `Legg til i Dock`,
's9af56bf005b49c74': `Rull ned til «Legg til på Hjem-skjerm»`,
'sa5ef80b4bb9b39f8': `Mindre`,
'sba52286c21552a4e': `Installer den på enheten din for å få en bedre brukeropplevelse og raskere tilgang.`,
'sc16e00a7a8b2fde2': `Tilbake`,
'scdaf4bbff76674c8': `Legg til på Hjem-skjerm`,
'se0e473adfda8066c': `Åpne i hovednettleseren din`,
'se740f75b95a51807': `Legg den til i Docken din for å få en bedre brukeropplevelse og raskere tilgang.`,
'sfea652f6580ff086': `Denne siden har app-funksjonalitet.`,
    };
  